fn update(
    inputBuffer: ptr<storage, array<vec4<f32>>, read_write>,
    densityBuffer: ptr<storage, array<f32>, read_write>,
    index: u32,
    count: u32,
    screenWidth: f32,
    screenHeight: f32,
    mouse: vec2<f32>,
    timeStep: f32
) -> void {
    var particle = inputBuffer[index];
    var pos = particle.xy;
    var vel = particle.zw;
    var density: f32 = 0.0;
    let center = vec2<f32>(screenWidth * 0.5, screenHeight * 0.5);
    let toCenter = center - pos;
    let distToCenter = max(length(toCenter), 0.001);

    // Parameters
    let force: f32 = 60.0; // パーティクル同士の影響範囲
    let mouseRange: f32 = 240.0; // マウスの影響範囲
    let friction:f32 = 0.95; // 摩擦力
    let cohesion:f32 = 300.0; // 凝集力

    for (var i: u32 = 0; i < count; i++) {
        if (i == index) { continue; }

        let other = inputBuffer[i];
        let otherPos = other.xy;
        let otherVel = other.zw;

        let dir = pos - otherPos;
        let dist = length(dir);

        if (dist < 15.0) {
            density += 1.0;
        }

        if (dist < force && dist > 0.001) {
            vel += (dir / dist) * (1.0 - dist / force);
            if (dist < force * 0.5) {
                 vel = vel * 0.97 + otherVel * 0.03;
            }
        }
    }
    densityBuffer[index] = density;

    let tangential = vec2<f32>(-toCenter.y, toCenter.x) / distToCenter;
    let swirlTarget = tangential * 90.0;
    vel = vel * 0.99 + swirlTarget * 0.01;

    // Mouse repulsion (applied after swirl so it is not washed out)
    let mouseDir = mouse - pos;
    let mouseDist = length(mouseDir);
    if (mouseDist > 0.001 && mouseDist < mouseRange) {
        let pull = (1.0 - (mouseDist / mouseRange)) * 140.0;
        vel -= (mouseDir / mouseDist) * pull;
    }

    // Cohesion back toward the center so scattered particles regroup.
    vel += (toCenter / distToCenter) * cohesion * timeStep;

    vel *= friction; // friction
    pos += vel * timeStep;

    // Boundary check
    if (pos.x < 0.0 || screenWidth < pos.x) {
        pos.x = clamp(pos.x, 0.0, screenWidth);
        vel.x *= -2.0;
    }
    if (pos.y < 0.0 || screenHeight < pos.y) {
        pos.y = clamp(pos.y, 0.0, screenHeight);
        vel.y *= -2.0;
    }

    // Write back
    inputBuffer[index] = vec4<f32>(pos, vel);
}
